import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const WorldHouseIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 375 374.999991" {...props}>
    <defs>
      <clipPath id="1cf67ef58c">
        <path
          d="M 20.023438 25.433594 L 355.273438 25.433594 L 355.273438 337 L 20.023438 337 Z M 20.023438 25.433594 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#1cf67ef58c)">
      <path
        fill="#231f20"
        d="M 197.785156 25.914062 L 40.292969 138.289062 L 40.292969 231.027344 L 20.023438 231.027344 L 20.023438 240.375 L 40.292969 240.375 L 40.292969 336.953125 L 191.546875 336.953125 L 191.546875 290.222656 L 218.0625 290.222656 L 218.0625 280.878906 L 191.546875 280.878906 L 191.546875 231.027344 L 49.648438 231.027344 L 49.648438 143.097656 L 197.785156 37.402344 L 345.917969 143.097656 L 345.917969 327.605469 L 296.019531 327.605469 L 296.019531 185.476562 L 270.082031 185.476562 L 276.65625 159.78125 L 305.25 159.78125 L 311.828125 185.476562 L 306.550781 185.476562 L 306.550781 194.824219 L 323.875 194.824219 L 312.511719 150.429688 L 269.386719 150.429688 L 258.035156 194.824219 L 286.667969 194.824219 L 286.667969 336.953125 L 355.273438 336.953125 L 355.273438 138.289062 Z M 182.191406 327.605469 L 49.648438 327.605469 L 49.648438 290.222656 L 182.191406 290.222656 Z M 182.191406 240.375 L 182.191406 280.878906 L 49.648438 280.878906 L 49.648438 240.375 Z M 182.191406 240.375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </g>
    <path
      fill="#231f20"
      d="M 115.339844 270.953125 C 119.214844 270.953125 122.351562 267.804688 122.351562 263.933594 C 122.351562 260.070312 119.214844 256.925781 115.339844 256.925781 C 111.457031 256.925781 108.320312 260.070312 108.320312 263.933594 C 108.320312 267.808594 111.457031 270.953125 115.339844 270.953125 Z M 115.339844 270.953125 "
      fillOpacity="1"
      fillRule="nonzero"
    />
    <path
      fill="#231f20"
      d="M 115.339844 315.925781 C 119.214844 315.925781 122.351562 312.78125 122.351562 308.914062 C 122.351562 305.042969 119.214844 301.902344 115.339844 301.902344 C 111.457031 301.902344 108.320312 305.039062 108.320312 308.914062 C 108.320312 312.785156 111.457031 315.925781 115.339844 315.925781 Z M 115.339844 315.925781 "
      fillOpacity="1"
      fillRule="nonzero"
    />
  </SvgIcon>
));

export default React.memo(WorldHouseIcon);
